import React, { useState, useEffect, useRef } from "react";
import {
  Button, Modal, ModalHeader, ModalBody,
  ModalFooter, Table
} from "reactstrap";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

toast.configure();

const SaveUnlabeledData = ({ items, showModal, setShowModel, _makeDoc }) => {
  const [confirm, setConfirm] = useState(false);
  const modalRef = useRef(null);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Enter') {
        confirmation();
      }
    };

    if (showModal) {
      document.addEventListener('keydown', handleKeyDown);
      if (modalRef.current) {
        modalRef.current.focus();
      }
    } else {
      document.removeEventListener('keydown', handleKeyDown);
    }

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [showModal, confirm]);

  const confirmation = () => {
    if (items.length && !confirm) {
      setConfirm(true);
      showModal = true;
    } else {
      _makeDoc();
    }
  };

  return (
    <>
      <Modal isOpen={showModal}
        backdrop="static"
        innerRef={modalRef}
        tabIndex="-1">
        <ModalHeader>
        </ModalHeader>
        <ModalBody>
          {!items.length ?
            <label><h4>
              Once you submit for processing, these changes cannot be undone.<br />
              Would you like to continue?
            </h4>

            </label> :

            !confirm ?
              <label>
                <h4>
                  Not all pages have been assigned to a document.<br />
                  Would you like to continue?
                </h4>
              </label> :
              <label><h4>
                Once you submit for processing, these changes cannot be undone.<br />
                Would you like to continue?
              </h4>

              </label>
          }
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => confirmation()}>
            Yes
          </Button>
          <Button color="link" onClick={() => { setShowModel(false); setConfirm(false); }} className="cancel-btn">
            No
          </Button>
        </ModalFooter>

      </Modal>
    </>
  );
};

export default SaveUnlabeledData;
